import classnames from 'classnames';

import Link from 'molecules/Link';

import styles from 'components/Header/NavMobile/nav-mobile.module.scss';
import NavMobilePanel from 'components/Header/NavMobilePanel';

import { isNonEmptyArray } from 'utils/functions';

import type { SiteMobileHeaderProps } from 'components/Header/SiteMobileHeader';
import type { FC } from 'react';

export interface NavMobileProps extends SiteMobileHeaderProps {
  openIndex: number | null;
  setOpen: (index: number) => void;
  closePanels: () => void;
  handleClick: () => void;
}

const learningCenterDomain = process.env.NEXT_PUBLIC_LEARNING_CENTER_SITE_DOMAIN;

const NavMobile: FC<NavMobileProps> = ({ closePanels, handleClick, menus, openIndex, setOpen }) => (
  <nav
    className={classnames(styles.menu, {
      [styles.openPanel]: openIndex !== null,
    })}
  >
    <ul className={styles.menuItems}>
      {menus?.map(
        ({ label = '', url = '', menuItems = [] }, index) =>
          (openIndex === index || openIndex === null) && (
            <li
              key={label}
              className={classnames(styles.listItem, {
                [styles.panelOpen]: openIndex === index,
              })}
            >
              <>
                {isNonEmptyArray(menuItems) ? (
                  <button className={styles.menuItem} onClick={() => setOpen(index)}>
                    {label}
                  </button>
                ) : (
                  <Link onClick={handleClick} className={styles.menuItem} href={url}>
                    {label}
                  </Link>
                )}
              </>
              {openIndex === index && menuItems && (
                <NavMobilePanel items={menuItems} closePanels={closePanels} handleClick={handleClick} />
              )}
            </li>
          ),
      )}
      {openIndex === null && (
        <>
          <li className={classnames(styles.listItem)}>
            <Link className={styles.menuItem} onClick={handleClick} href="/quote">
              Get A Quote
            </Link>
          </li>
          <li className={classnames(styles.listItem)}>
            <Link className={styles.menuItem} onClick={handleClick} href="/faq">
              FAQ
            </Link>
          </li>
          <li className={classnames(styles.listItem)}>
            <Link className={(styles.menuItem, styles.menuItemUtility)} onClick={handleClick} href="/claims-911">
              Claims 911
            </Link>
          </li>
          <li className={classnames(styles.listItem, styles.listItemHalf)}>
            <Link className={styles.menuItem} onClick={handleClick} href={learningCenterDomain || ''}>
              Login
            </Link>
          </li>
          <li className={classnames(styles.listItem, styles.listItemHalf)}>
            <Link className={styles.menuItem} onClick={handleClick} href="/search">
              Search
            </Link>
          </li>
        </>
      )}
    </ul>
  </nav>
);

export default NavMobile;
